import "../Assets/Css/Spinner.css";
const Spinner = () => {
	return (
		<div className="loader-full">
			<div className="spinner-border" role="status">
				<span className="sr-only">Loading...</span>
			</div>
		</div>
	);
};
export default Spinner;
